<script setup lang="ts">
import ChevronDown from 'assets/icons/ChevronDown.svg'
import DownloadReportIcon from 'assets/icons/DownloadReportIcon.svg'

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: true,
  },
)

const emit = defineEmits<{
  download: [type: string]
}>()

const options = [
  {
    id: 'chart-download-csv-button',
    name: 'Download XLSX',
    shortName: 'XLSX',
    value: 'xlsx',
    icon: DownloadReportIcon,
  },
  {
    id: 'chart-download-png-button',
    name: 'Download PNG',
    shortName: 'PNG',
    value: 'png',
    icon: DownloadReportIcon,
  },
]

const download = (type: string) => {
  emit('download', type)
}
</script>

<template>
  <div class="group relative inline-block">
    <button
      data-testid="chart-download-button"
      class="flex w-full items-center justify-center rounded border border-grey-600 bg-white px-4 py-2 font-semibold text-s-900 disabled:opacity-25 lg:px-3"
      :class="{
        'pointer-events-none': disabled,
      }"
      :disabled="disabled"
    >
      <span
        class="text-left font-montserrat text-sm font-semibold lg:w-auto lg:text-xs"
      >
        Download
      </span>
      <ChevronDown class="h-6 w-6 group-hover:rotate-180" />
    </button>
    <div
      v-if="!disabled"
      class="absolute hidden w-full rounded bg-s-50 py-1 shadow-[0_4px_10px_rgba(0,0,0,0.5)] group-hover:block"
    >
      <button
        v-for="option in options"
        :key="option.id"
        :data-testid="option.id"
        type="button"
        class="relative mx-auto flex w-full flex-row items-center overflow-hidden bg-s-50 px-3 py-2 text-black hover:bg-p-200"
        @click="download(option.value)"
      >
        <span class="flex gap-x-2 text-xs font-normal lg:hidden">
          <Component :is="option.icon" class="h-4 w-4" />
          {{ option.name }}
        </span>
        <span class="hidden text-xs font-normal lg:block">
          {{ option.shortName }}
        </span>
      </button>
    </div>
  </div>
</template>
